import axios from '@/lib/axios';
import SignInParams from '@/features/customer/auth/types/SignInParams';

const signIn = (data: SignInParams) => {
  return axios.post('/customer/sign_in', data);
}

export default signIn;